import { createContext, useState, useEffect } from 'react';
import en from './locales/en.json';
import ge from './locales/ge.json';
import it from './locales/it.json';
import ar from './locales/ar.json';
import tr from './locales/tr.json';
import ru from './locales/ru.json';
import i18n from '../i18n';

const languageSet = { en, ge, it, ar, tr, ru };

const deepMerge = (fallback, current) => {
  if (!fallback || typeof fallback !== 'object') return current;
  const output = { ...fallback };
  Object.entries(current || {}).forEach(([key, value]) => {
    output[key] = value && typeof value === 'object' && !Array.isArray(value)
      ? deepMerge(fallback[key], value)
      : value;
  });
  return output;
};

export const LocalizationContext = createContext({
  translations: en,
  switchLanguage: () => {},
  locale: 'en',
  isLoading: false,
});

export const LocalizationProvider = ({ children }) => {
  const [locale, setLocale] = useState(localStorage.getItem('selectedLanguage') || 'en');
  const [translations, setTranslations] = useState(deepMerge(en, languageSet[locale]));
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTranslations(deepMerge(en, languageSet[locale] || en));
    i18n.changeLanguage(locale);
  }, [locale]);

  const switchLanguage = async (language) => {
    setIsLoading(true);
    
    await new Promise(resolve => setTimeout(resolve, 300));
    
    setLocale(language);
    i18n.changeLanguage(language);
    localStorage.setItem('selectedLanguage', language);
    
    await new Promise(resolve => setTimeout(resolve, 200));
    setIsLoading(false);
  };

  return (
    <LocalizationContext.Provider value={{ translations, switchLanguage, locale, isLoading }}>
      {children}
    </LocalizationContext.Provider>
  );
};
